import React from 'react';
import { text } from '../../data';

interface ToggleButtonProps {
	buttonStyle: string | undefined;
	isOpen: boolean;
	isLoggedIn: boolean;
	isResultsReady?: boolean;
	toggleMenu: () => void;
}

const ToggleButton: React.FC<ToggleButtonProps> = React.memo(({
	buttonStyle,
	isOpen,
	isLoggedIn,
	isResultsReady,
	toggleMenu,
}) => {
	const disabled = ! isLoggedIn || ! isResultsReady;

	const sharedProps = {
		className: 'btn btn--secondary dropdown-toggle projects-save__toggle',
		type: 'button' as const,
		id: 'reports-save__toggle',
		'aria-expanded': isOpen,
		onClick: toggleMenu,
		disabled,
	};

	return (
		<button {...sharedProps}>
			{buttonStyle === 'full' ? (
				<>
					<i className={isLoggedIn ? 'icon-folder-outline' : 'icon-lock'}></i>
					<span className="action__text">{text.addToProject}</span>
				</>
			) : (
				<>
					<i className={isLoggedIn ? '' : 'icon-lock'}></i>
					<span className="action__text">{text.saveReport}</span>
				</>
			)}
		</button>
	);
});

export default ToggleButton;
